module.exports = "/images/Assemble.svg";